import React, { Fragment } from 'react';
import cn from 'classnames';
import { string, node, oneOfType, func } from 'prop-types';
import { parseHtml } from '../../utils';
/**
 * EditorContent component.
 */

var EditorContent = function EditorContent(_ref) {
  var children = _ref.children,
      className = _ref.className,
      gtmLabel = _ref.gtmLabel,
      wrapper = _ref.wrapper;
  var Wrapper = Fragment;
  var html = parseHtml(children);
  var firstNode = Array.isArray(html) ? html[0] : html;
  var firstNodeType = firstNode === null || firstNode === void 0 ? void 0 : firstNode.type;
  var firstNodeHasAttrs = !!Object.keys((firstNode === null || firstNode === void 0 ? void 0 : firstNode.props) || {}).filter(function (key) {
    return key !== 'children';
  }).length; // For the case where the HTML string may or may not already start with the
  // wrapping element (e.g. a <p>).

  if (wrapper && (typeof wrapper !== 'string' || wrapper !== firstNodeType || firstNodeHasAttrs)) {
    Wrapper = wrapper;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: cn('editor-content', className),
    "data-gtm-class": gtmLabel
  }, /*#__PURE__*/React.createElement(Wrapper, null, html));
};

EditorContent.defaultProps = {
  children: null,
  className: null,
  gtmLabel: null,
  wrapper: null
};
EditorContent.propTypes = process.env.NODE_ENV !== "production" ? {
  /** The content blocks */
  children: node,

  /** Additional classes to add to the root of the component. */
  className: string,

  /** A label to be used for GTM tracking. */
  gtmLabel: string,

  /** An optional element, or component accepting children, to wrap around
   * the editor content. */
  wrapper: oneOfType([string, node, func])
} : {};
export default EditorContent;